import {
  isLocal,
  isTestnet,
} from '../../constants/envs';

const isSandbox = isLocal || isTestnet;

export const immutableConfig = {
  // Public client ID and public key from https://hub.immutable.com
  // NOTE: clientId stored also in cs-api-core
  clientId: isSandbox
    ? '2kv1Q6ApSnidVYzxDu3DvKCFfdrYTttd'
    : 'wdOO9lUaknNE2vmoMbuM3T1jsmJcHzZg',
  publishableKey: isSandbox
    ? 'pk_imapik-test-77VHGl62oFPKZVZdkPu-' // Optional: Only if we have a 'pk_' key from Immutable
    : 'pk_imapik-Hmmj3xZ$P_B-HWzyRZsC',
  redirectUri: isSandbox
    ? `${isLocal
        ? window.location.href
        : 'https://playtest.crypto-shots.com/'
      }auth/callback`
    : 'https://play.crypto-shots.com/auth/callback',
  environment: isSandbox
    ? 'sandbox'
    : 'production',
};

isSandbox && console.log('[imx] local config:', immutableConfig);
